import { Tooltip, IconButton } from "@mui/material"
import ConstructionIcon from '@mui/icons-material/Construction';
export default function ShowUnassignedButton({setShowUnassigned, showUnassigned}) {

    return (
        <Tooltip title="Unassigned" placement="left">
            <IconButton 
                onClick={() => 
                    setShowUnassigned(!showUnassigned)
                }
                sx={{
                    position: "fixed", 
                    backgroundColor: '#DC053C', 
                    bottom: "20px", 
                    right: "20px", 
                    height: "48px", 
                    width: "48px", 
                    lineHeight: "24px", 
                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 0px 8px 4px",
                    "&:hover": {
                        backgroundColor: '#C50935',
                    }
                }}>
                <ConstructionIcon sx={{height: "24px", width: "24px", color: "#fff"}} />
            </IconButton>
        </Tooltip>
    )
}